import React from 'react';

// Components
import { Row, Column } from '@pella/sash-framework';

// Styles
import styles from './index.module.scss';

const TimeslotHeader = () => (
	<Row className={styles.rtaCalendar_Timeslot_Row}>
		<Column
			className={styles.rtaCalendar_Timeslot_Header}
			xs='4'
		>
			<p className={styles.rtaCalendar_Timeslot_Header_Data}>Morning</p>
		</Column>
		<Column
			className={styles.rtaCalendar_Timeslot_Header}
			xs='4'
		>
			<p className={styles.rtaCalendar_Timeslot_Header_Data}>Afternoon</p>
		</Column>
		<Column
			className={styles.rtaCalendar_Timeslot_Header}
			xs='4'
		>
			<p className={styles.rtaCalendar_Timeslot_Header_Data}>Evening</p>
		</Column>
		<Column xs='12'>
			<hr />
		</Column>
	</Row>
);

export default TimeslotHeader;
